<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow" :header="false">
      <template v-slot:header></template>
      <template v-slot:title>
        <v-row class="ma-1">
          <v-btn-toggle v-model="objectType" mandatory borderless dense @change="onChangeObjectType" class="ml-1">
            <v-btn value="objects" class="mx-1">
              <span class="hidden-md-and-down">Объекты</span>
              <v-icon :right="$vuetify.breakpoint.mdAndUp"> far fa-building </v-icon>
            </v-btn>
            <v-btn value="lampObjects" class="mr-1" v-if="isShow('lampObjects')">
              <span class="hidden-md-and-down">Рекламные</span>
              <v-icon :right="$vuetify.breakpoint.mdAndUp">fas fa-lightbulb</v-icon>
            </v-btn>
            <v-btn value="agentObjects" class="mr-1" v-if="isShow('agentObjects')">
              <span class="hidden-md-and-down">Агенты</span>
              <v-icon :right="$vuetify.breakpoint.mdAndUp"> fas fa-user-secret </v-icon>
            </v-btn>
            <v-btn value="partnerObjects" v-if="isShow('partnerObjects')">
              <span class="hidden-md-and-down">Партнеры</span>
              <v-icon :right="$vuetify.breakpoint.mdAndUp"> fas fa-handshake </v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="$refs.table.updateData()"><btn-title icon="fas fa-sync-alt">Обновить</btn-title> </v-btn>
      </template>
      <a-table-f-api
        ref="table"
        :api="types[objectType].url"
        :model="model"
        :useQuery="!true"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
        @click1="onClickRow($event)"
      >
        <template v-slot:item.actions="{ row }">
          <div class="d-flex">
            <v-btn
              elevation="0"
              :loading="!!(pdfLoading[objectType + '_' + row.id] && pdfLoading[objectType + '_' + row.id] == 1)"
              :disabled="!!pdfLoading[objectType + '_' + row.id]"
              x-small
              fab
              class="ma-0 ml-1"
              color="green"
              title="скачать"
              @click.stop="getPdf(row, 0)"
            >
              <v-icon>fas fa-file-export</v-icon>
            </v-btn>
            <v-btn v-if="false" elevation="0" x-small fab class="ma-0 ml-1" color="green" title="Просмотр" @click.stop="openLink(row, 1)">
              <v-icon>fas fa-eye</v-icon>
            </v-btn>
          </div>
        </template>
      </a-table-f-api>
    </static-fullscreen-card>
    <s-edit-form-async ref="editField" />
    <ViewItem v-if="idItemShow" :idShow="idItemShow" :type="objectType" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, keyDetect, doubleClickDetect, genModel } from "@/components/mixings";
import objects from "@/mixins/objects";

export default {
  components: {
    ViewItem: () => import("./views/salesView"),
  },
  mixins: [getAccess, keyDetect, doubleClickDetect, genModel, objects],
  data() {
    return {
      idEdit: 0,
      idItemShow: 0,
      objectType: "objects",
      showEditDialog: false,
      title: "",
      types: {
        objects: { url: "/mechti/objects/broker" },
        lampObjects: { url: "/mechti/lamp_objects" },
        agentObjects: { url: "/mechti/agent_objects" },
        partnerObjects: { url: "/mechti/partner_objects" },
      },
      apiPrint: {
        objects: { url: "/mechti/objects/published" },
        lampObjects: { url: "/mechti/lamp_objects" },
        agentObjects: { url: "/mechti/agent_objects" },
        partnerObjects: { url: "/mechti/partner_objects" },
      },
      m: this.$store.getters["config/get"].models.sales,
      url: "/mechti/objects/broker",
    };
  },
  computed: {
    defaults() {
      let d = {
        futureFlatRepairAfterDeal: 0,
        contactAvito_id: 6,
        contactCian_id: 6,
        subAgent_id: null,
        versionAvito: 1,
        versionCian: 1,
        metro: null,
        bet: null,
        parking: null,
        description:
          "ID 757\n\nДом построен в 2023, в очень живописном лесу\nна 30 сотках, на берегу Генеральского озера.\n● 812 м² + 152,5 м² гараж на 2 машиноместа + блок\nдля персонала\n● второй свет\n● бассейн в доме с зоной спа и с видом на лес\n● кабинет со стеклянной стеной и\nвидом на второй свет и на лес с балконом,\n● мастер-спальня с витражами и видом на лес\nс огромной гардеробной м/ж (всего 6 спален)\n● санузел с отдельно стоящей ванной\n● 6 спален\n● кинотеатр\n● постирочная\n● спортзал\n● винная комната.\n\nДвухэтажный коттедж с дизайнерским ремонтом в лесу у озера\nДом 1000 кв.м, с зоной для персонала и гаражом.\nМосква, 13 км. Новорижского шоссе, СНТ «Усадьба»\nЦоколь:\nКладовая - 32,20 кв/м\nТренажерный зал - 63,02 кв/м\nВинная комната - 10,80 кв/м\nГардеробная - 14,06 кв/м\nС/у - 7,33 кв/м\nПостирочная - 26,63 кв/м\nКотельная - 11,64 кв/м\nИтого: 165,58 кв/м\n\nПервый этаж:\nВходная группа - 14,10 кв/м\nС/у - 4,29 кв/м\nГостевая спальня - 21,80 кв/м\nСауна - 9,61 кв/м\nДушевая - 1,33 кв/м\nС/у - 1,33 кв/м\nЗона спа - 77,29 кв/м\nКухня-гостиная - 75,37 кв/м\nПрихожая зона - 5,74 кв/м\nИтого: 210,86 кв/м\n\nВторой этаж:\nХолл - 14,64 кв/м\nКабинет - 14,91 кв/м\nС/у - 12,23 кв/м\nГардеробная - 6,48 кв/м\nДетская - 21,80 кв/м\nМастер-блок - 26,16 кв/м\nМужская гардеробная - 9,82 кв/м\nМастер с/у - 13,35 кв/м\nЖенская гардеробная - 14,69 кв/м\nМастер-спальня - 30,97 кв/м\nИтого: 165,05 кв/м\n\nМансарда:\nЗона кинотеатра - 36,99 кв/м\nС/у - 8,14 кв/м\nСпальня 1 - 32,21 кв/м\nСпальня 2 - 22,60 кв/м\nСпальня 3 - 17,94 кв/м\nИтого: 117,88 кв/м",
        description_cian:
          "ID 757\n\nДом построен в 2023, в очень живописном лесу\nна 30 сотках, на берегу Генеральского озера.\n● 812 м² + 152,5 м² гараж на 2 машиноместа + блок\nдля персонала\n● второй свет\n● бассейн в доме с зоной спа и с видом на лес\n● кабинет со стеклянной стеной и\nвидом на второй свет и на лес с балконом,\n● мастер-спальня с витражами и видом на лес\nс огромной гардеробной м/ж (всего 6 спален)\n● санузел с отдельно стоящей ванной\n● 6 спален\n● кинотеатр\n● постирочная\n● спортзал\n● винная комната.\n\nДвухэтажный коттедж с дизайнерским ремонтом в лесу у озера\nДом 1000 кв.м, с зоной для персонала и гаражом.\nМосква, 13 км. Новорижского шоссе, СНТ «Усадьба»\nЦоколь:\nКладовая - 32,20 кв/м\nТренажерный зал - 63,02 кв/м\nВинная комната - 10,80 кв/м\nГардеробная - 14,06 кв/м\nС/у - 7,33 кв/м\nПостирочная - 26,63 кв/м\nКотельная - 11,64 кв/м\nИтого: 165,58 кв/м\n\nПервый этаж:\nВходная группа - 14,10 кв/м\nС/у - 4,29 кв/м\nГостевая спальня - 21,80 кв/м\nСауна - 9,61 кв/м\nДушевая - 1,33 кв/м\nС/у - 1,33 кв/м\nЗона спа - 77,29 кв/м\nКухня-гостиная - 75,37 кв/м\nПрихожая зона - 5,74 кв/м\nИтого: 210,86 кв/м\n\nВторой этаж:\nХолл - 14,64 кв/м\nКабинет - 14,91 кв/м\nС/у - 12,23 кв/м\nГардеробная - 6,48 кв/м\nДетская - 21,80 кв/м\nМастер-блок - 26,16 кв/м\nМужская гардеробная - 9,82 кв/м\nМастер с/у - 13,35 кв/м\nЖенская гардеробная - 14,69 кв/м\nМастер-спальня - 30,97 кв/м\nИтого: 165,05 кв/м\n\nМансарда:\nЗона кинотеатра - 36,99 кв/м\nС/у - 8,14 кв/м\nСпальня 1 - 32,21 кв/м\nСпальня 2 - 22,60 кв/м\nСпальня 3 - 17,94 кв/м\nИтого: 117,88 кв/м",
        latitude: null,
        longitude: null,
        isDefaultLayout: 0,
        layoutPhoto: ["d4e6fe717dca2fad106a45034098b9cc", "39c8e5cf939c83d1d791c8f3ef392a7d", "ec2ba60e1d16ff29cc0f14c5edfe2a86", "7a6c0af63e621c3ae96bfd8e68ecbe7f"],
        photos: [
          "521d4f2051310b349879c4971f4175bb",
          "fc59786a054e99e995bc87c63d3eec8e",
          "705d83308263b7e861486f61ed8f43df",
          "3324922e7b271f079c64b0d89f0ed861",
          "c7e594c0a2079aba32d1fb375b40f099",
          "acde08567b1bfab59c8caa3aaf971af7",
          "0ac8991491cbfb0f9f16c17e55efab3a",
          "579d3d449cc94a44668fe377a76e25cb",
          "e29d425e72fdd3e41c833bc41db6c365",
          "60dc06ea7ffc13e95672aee5acde7104",
          "7392ed7be87e9395dc4a379e30c84aa7",
          "16422dc2d6e6555e705bdeb3749935b2",
          "65ce8ba702009bf0e9fcc20c3461d61b",
          "91856ba363e93ff36e76317766a5f2ee",
          "4aae696bce3590ad66af4d43fbc90640",
          "4e1ac81f92ea62485139482caf8052b7",
          "eaa3ad96ca876c784a078b832fdaea1e",
          "ed01b662e6a52c0d7171b3a2ce8b5f4b",
          "ebd8302c25c5cd04bbae80c343ea0901",
          "c13a55c8c5079a786274306346baa32f",
          "806f574f82594e6c4164840e98e55c48",
          "e74886ca3cae4870328d852f4fd44e93",
          "96ebea3ee69bf3053e72b66498fb1221",
          "57d813d1056a0976ed9ff33af7ba7440",
          "4691df1386c68b824532bf3aa099cbaf",
        ],
        photos_avito: null,
        videoURL: null,
        cadastralNumber: null,
        price: null,
        passengerElevator: 0,
        freightElevator: 0,
        balconies: 0,
        loggias: 0,
        wardrobe: 0,
        windows: 0,
        separateWcsCount: 0,
        combinedWcsCount: 0,
        repair_type: "design",
        videoURL_cian: null,
        residential_house_id: null,
        title_cian: "",
      };
      let res = {
        sort: { key: "id", order: "DESC" },
        filters: { status: this.objectType == "objects" ? 10 : undefined },
        paramName: "sales",
      };
      return res;
    },
    modelT() {
      console.log("get model T");
      return this.getModelList(this.m, "list", false);
    },
    model() {
      let res = this.modelT;
      let fields = this.m[this.objectType].split(",");
      let opt = [];
      if (this.objectType == "objects") opt = this.getOptions({ options: "status_object" });
      if (this.objectType == "lampObjects") opt = this.getOptions({ options: "config.statuses.lamp_object" }).filter(s => s.type == "lampObjects");
      if (this.objectType == "agentObjects") opt = this.getOptions({ options: "config.statuses.lamp_object" }).filter(s => s.type == "agentObjects");
      if (this.objectType == "partnerObjects") opt = this.getOptions({ options: "config.statuses.lamp_object" }).filter(s => s.type == "partnerObjects");
      res.find(m => m.name == "status").options = [...opt];
      // res.find((m) => m.name == "ap_price_buy").editable = !(this.objectType == "objects");
      return res.filter(f => fields.includes(f.name));
    },
  },
  created() {
    this.$root.title = "Продажи";
  },
  methods: {
    isShow(n) {
      return !(this.m.tabs?.[n]?.hidden || false);
    },

    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
    onDoubleClick(d) {
      this.idItemShow = d.row.id;
      return;
    },
    onClickRow(d) {
      this.$router.push({ name: "sales_view", params: { type: this.objectType, id: d.row.id } });
      // this.showEditDialogFun(d.row.id);
    },
    onChangeObjectType() {
      if (this.$refs.table) {
        this.$refs.table.refresh();
      }
    },
  },
};
</script>
